import React, { useMemo } from 'react'

import { GetCustomerCartQuery } from '../../graphql/magento'
import { readCartDispensaryPromoCodes } from '../../lib/cart/dispensary-promo'
import { totalQuantityExcludingDependents } from '../../lib/cart/item'
import { CartState, ToggleCodesAction } from '../../lib/cart/reducers/cart-state'
import AddPromoCode from './AddPromoCode'
import AppliedPromoCode from './AppliedPromoCode'
import CartSummaryRow from './CartSummaryRow'

export interface CartPromoCodeProps extends Pick<CartState, 'codesCollapsed' | 'formDisabled'> {
  cart: NonNullable<GetCustomerCartQuery['customerCart']>
  dispatch: React.Dispatch<ToggleCodesAction>
}

const CartPromoCode: React.FC<CartPromoCodeProps> = ({
  cart,
  codesCollapsed,
  formDisabled,
  dispatch,
}) => {
  const {
    applied_coupons: appliedCoupons,
    id: cartId,
    items,
    dispensary_promo_code: dispensaryPromoCode,
    total_quantity: totalQuantity,
  } = cart

  const cartDispensaryPromoCodes = useMemo(
    () => (dispensaryPromoCode ? readCartDispensaryPromoCodes(dispensaryPromoCode) : undefined),
    [dispensaryPromoCode],
  )

  const cartTotalQuantity = totalQuantityExcludingDependents(items, totalQuantity)

  return (
    <>
      <CartSummaryRow>
        <AddPromoCode
          cartDispensaryPromoCodes={cartDispensaryPromoCodes}
          cartId={cartId}
          formDisabled={formDisabled}
          isEmptyCart={cartTotalQuantity === 0}
        />
      </CartSummaryRow>
      {!!appliedCoupons?.length && (
        // disable gutter since toggle button adds 10px padding to increase touch target
        <CartSummaryRow $gutterBottom={false}>
          <AppliedPromoCode
            appliedCoupons={appliedCoupons}
            cartDispensaryPromoCodes={cartDispensaryPromoCodes}
            cartId={cartId}
            codesCollapsed={codesCollapsed}
            dispatch={dispatch}
          />
        </CartSummaryRow>
      )}
    </>
  )
}

export default CartPromoCode
